module.exports = __webpack_public_path__ + "static/media/logo-white.ff06c748.png";